// Unpublished Work © 2020-2022 Deere & Company

import {applicationStatus} from './application-status';
import {combineReducers} from 'redux';
import {CustomerSearch} from '../../state/struct/customer-search/customer-search';
import {customers} from './customers';
import {savedSearchPreferences} from './saved-search-preferences';
import {facetOptions} from './facet-options';
import {selectedFacets} from './selected-facets';
import {reducerTcombWrapper} from '@deere/cap-it-ui.redux-store-creator';
import {mergeCustomer} from './merge-customer';

export const getCustomerSearchCombinedReducer = () => {
    const combinedReducer = combineReducers({
        applicationStatus,
        customers,
        facetOptions,
        mergeCustomer,
        savedSearchPreferences,
        selectedFacets
    });

    return reducerTcombWrapper.bind(
        this,
        {
            combinedReducer,
            stateStruct: CustomerSearch
        }
    );
};
